import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { filter, find, forEach, get, isEmpty, isUndefined, map } from "lodash";
import FulfillmentNodeService from "../../backend/FulfillmentNodeService";
import BrandStyleSheet from "../precheckin/BrandStyleSheet";
import { Flex } from "../../styles/GlobalStyle";
import Selector from "../../components/Selector";
import TopBar from "../../components/navbar/TopBar";
import Property from "../../model/property";
import {
  FlexContainer,
  NavBarLink,
  SmallTitle,
} from "../productdetail/style/ProductDetailStyle";
import LoadingIcon from "../../components/LoadingIcon";
import moment from "moment";
import ConfirmOrderAskRoomLastNameModal from "../../components/modal/ConfirmOrderAskRoomLastNameModal";
import ConfirmationFulfillmentModal from "../../components/modal/ConfirmationFulfillmentModal";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderSquare from "../../assets/placeholder-square.png";
import storeFunction from "../../utils/storeFunction";
import FulfillmentService from "../../backend/FulfillmentService";
import FulfillmentNode from "../../model/fulfillmentNode";
import { ProductPanel, ListHeaderTitle, ListSubTitle } from "./LobbyrowStyle";
import ErrorModal from "../../components/modal/ErrorModal";
import TokenService from "../../backend/TokenService";

class FulfillmentDetail extends Component {
  state = {
    propertyUid: null,
    lobbyRowId: null,
    fulfillmentId: null,
    presets: null,
    lobbyRow: null,
    fulfillmentNode: null,
    fulfillmentNodeSchema: null,
    auto_reply_message: null,
    roomNumber: null,
    error: false,
    loading: true,
    arraySelector: null,
    language: "en",
    showConfirmation: false,
    showSecondConfirmation: false,
    products: [],
    hasError: false,
    btnErrorText: "",
    accessToken: null,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.initStore();

    const { propertyUid, lobbyId, fulfillmentId } = this.props.match.params;
    const splitFulfillment = fulfillmentId.split("?");
    const fId = splitFulfillment[0];
    const lang =
      splitFulfillment.length > 1 &&
      splitFulfillment[1].split("=").length > 1 &&
      splitFulfillment[1].split("=")[1];
    const query = new URLSearchParams(this.props.location.search);
    const language =
      query.get("language") || lang || this.props.i18n.language || "en";

    const presets = Property.getPreset();
    if (presets && !isEmpty(presets.app_webstore_favicon_url)) {
      const favicon = document.getElementById("favicon");
      if (favicon) favicon.href = presets.app_webstore_favicon_url;
      const appleFavicon = document.getElementById("apple-favicon");
      if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
    }

    this.setState({
      propertyUid: propertyUid,
      lobbyRowId: lobbyId,
      language: language,
      presets: presets,
      fulfillmentId: fId,
    });
    this.getFulfillment(propertyUid, lobbyId, fId, language);
  }

  initStore() {
    FulfillmentNode.clearData();
    FulfillmentNode.clearCartItem();
    Property.clearOrderSuccess();
  }

  getFulfillment = async (
    propertyUid,
    lobbyId,
    fulfillmentId,
    language = "en"
  ) => {
    if (lobbyId) {
      try {
        await FulfillmentNodeService.getFulfillment(
          propertyUid,
          lobbyId,
          fulfillmentId,
          language
        )
          .then((response) => {
            const lobbyRow = response.data;
            FulfillmentNode.setData(lobbyRow);
            const fulfillmentNode =
              lobbyRow &&
              lobbyRow.fulfillmentnodes.length > 0 &&
              lobbyRow.fulfillmentnodes[0];
            const schema = JSON.parse(fulfillmentNode.schema);
            const arraySelector = schema.data.selections;
            this.setState({
              lobbyRow: lobbyRow,
              fulfillmentNode: fulfillmentNode,
              fulfillmentNodeSchema: schema,
              arraySelector: arraySelector,
              auto_reply_message: schema.data.auto_reply.message,
              success: true,
              loading: false,
            });
          })
          .catch((err) => {
            this.setState({ loading: false, success: false, error: true });
            throw err;
          });
      } catch (err) {
        this.setState({ loading: false, success: false, error: true });
      }
    }
  };

  bottomBar = (preset, productUrl, bottomText) => {
    return (
      <NavBarLink
        id="bottom-bar-link"
        onClick={(e) => this.navbarClicked(e)}
        className="cursor-pointer"
        app_home_color_primary={preset.app_home_color_primary}>
        <FlexContainer>
          <SmallTitle
            className={"textStyle"}
            app_home_text_top_nav={preset.text_color}>
            {bottomText}
          </SmallTitle>
        </FlexContainer>
      </NavBarLink>
    );
  };

  async getAccessToken(propertyUid) {
    const response = await TokenService.getProperty(propertyUid);
    const accessToken = response.data;
    this.setState({
      accessToken: accessToken.access_token,
    });
  }

  navbarClicked = (e) => {
    let itemSelection = "";
    let validateDataInput = true;
    let selectionOptions = [];
    let itemAutoReminder = [];
    const selectors = this.state.arraySelector;
    this.setState({
      checkValidation: true,
    });

    for (let i = 0; i < selectors.length; i++) {
      const selectionType = selectors[i].selection_type;
      const shouldSetValueAsText =
        selectionType === "pick_date" ||
        selectionType === "pick_time" ||
        selectionType === "pick_time_relative" ||
        selectionType === "pick_date_and_time" ||
        selectionType === "pick_date_and_static_time" ||
        selectionType === "pick_date_spa_booker" ||
        selectionType === "pick_number" ||
        selectionType === "text_input" ||
        selectionType === "text_input_room";

      if (shouldSetValueAsText) {
        selectionOptions.push({
          id: selectors[i].id || i,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          autoReminder: selectors[i].auto_reminder || false,
          values: [{ value: selectors[i].values || "-" }],
        });
      } else if (["pick_product_price"].includes(selectionType)) {
        selectionOptions.push({
          id: selectors[i].id || i,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, ({ value }) => value > 0),
            (data) => ({
              ...data,
              value: `${data.name}x${data.value} (${data.value * data.price})`,
              counter: data.value,
            })
          ),
        });
      } else if (
        selectionType === "pick_one" ||
        selectionType === "pick_multiple"
      ) {
        selectionOptions.push({
          id: selectors[i].id || i,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, { select: true }),
            (data) => ({
              ...data,
              value: data.name,
            })
          ),
        });
      } else if (
        selectionType === "pick_one_price" ||
        selectionType === "pick_multiple_price"
      ) {
        selectionOptions.push({
          id: selectors[i].id || i,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, { select: true }),
            (data) => ({
              ...data,
              value: `${data.name} ${data.price}`,
            })
          ),
        });
      } else if (selectionType === "pick_dropdown") {
        selectionOptions.push({
          id: selectors[i].id || i,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, { select: true }),
            (data) => ({ ...data, value: `${get(data, "name", "")}` })
          ),
        });
      } else {
        selectionOptions.push({
          id: selectors[i].id || i,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: filter(selectors[i].values, { select: true }),
        });
      }

      if (shouldSetValueAsText) {
        itemSelection +=
          selectors[i].title + ": " + (selectors[i].values || "-") + "\n";
        if (selectors[i].force_input) {
          if (!selectors[i].values) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (selectionType === "pick_one") {
        itemSelection += selectors[i].title + ": ";
        let pickOneValid = false;
        for (let l = 0; l < selectors[i].values.length; l++) {
          if (selectors[i].values[l].select) {
            if (selectionType === "pick_one") {
              itemSelection += selectors[i].values[l].name + "\n";
            }
          }

          if (selectors[i].force_input) {
            if (selectors[i].values[l].select === true) {
              pickOneValid = true;
              break;
            }
          }
        }

        if (selectors[i].force_input && !pickOneValid) {
          validateDataInput = false;
          break;
        }
      }

      if (
        selectionType === "pick_multiple" ||
        selectionType === "pick_multiple_price" ||
        selectionType === "pick_one_price"
      ) {
        itemSelection += selectors[i].title + ": ";
        let pickMultipleValid = false;

        for (let k = 0; k < selectors[i].values.length; k++) {
          if (selectors[i].values[k].select) {
            if (
              selectionType === "pick_multiple_price" ||
              selectionType === "pick_one_price"
            ) {
              itemSelection +=
                selectors[i].values[k].name +
                " (+" +
                selectors[i].values[k].price +
                ")";
            }

            if (selectionType === "pick_multiple") {
              itemSelection += selectors[i].values[k].name + ", ";
            }
          }
        }
        for (let k = 0; k < selectors[i].values.length; k++) {
          if (selectors[i].force_input) {
            if (selectors[i].values[k].select === true) {
              pickMultipleValid = true;
              break;
            }
          }
        }

        itemSelection += "\n";
        if (selectors[i].force_input && !pickMultipleValid) {
          validateDataInput = false;
          break;
        }
      }

      if (["pick_product_price"].includes(selectionType)) {
        const itemSelected = [];
        itemSelection += selectors[i].title + ": ";

        forEach(selectors[i].values, (data) => {
          if (data.value > 0) {
            itemSelected.push(
              `${data.name}x${data.value} (${data.value * data.price})`
            );
          }
        });
        itemSelection += itemSelected.join("\n");
      }

      if (selectionType === "pick_dropdown") {
        const dataSelected = find(selectors[i].values, { select: true });
        itemSelection += `${selectors[i].title}: ${get(
          dataSelected,
          "name",
          ""
        )}\n`;
        if (selectors[i].force_input && isUndefined(dataSelected)) {
          validateDataInput = false;
          break;
        }
      }
      if (
        ["pick_date_and_time", "pick_time"].includes(selectionType) &&
        selectors[i].auto_reminder
      ) {
        let text;

        if (
          Array.isArray(selectors[i].values) &&
          selectors[i].values.length > 0 &&
          selectors[i].values[0].value
        ) {
          text = selectors[i].title + ": " + selectors[i].values[0].value;
        } else {
          text = selectors[i].title + ": " + selectors[i].values;
        }
        const dataAutoReminder = {
          title: text,
          timestamp: selectors[i].timestamp,
        };
        itemAutoReminder.push(dataAutoReminder);
      }
    }

    const productItem = Property.getProductDetailData();
    const uid = productItem ? productItem.uid : "";
    const itemName = productItem ? productItem.title : "";
    const subTitle = productItem ? productItem.subtitle : "";
    const payload = {
      uid,
      item_selection: itemSelection,
      item_name: itemName,
      item_subtitle: subTitle,
      selection_options: selectionOptions,
    };
    if (itemAutoReminder.length > 0) {
      payload["auto_reminder_base_time"] = itemAutoReminder;
    }
    if (!validateDataInput) {
      this.setState({ requiredField: true });
      e.preventDefault();
    } else {
      FulfillmentNode.setCartItem(payload);
      Property.popPreviousTitle();

      this.showModal();
    }
  };

  showModal = () => {
    let itemSelection = "";
    let selectionOptions = [];
    let validateDataInput = true;
    let hasError = false;

    this.setState({
      checkValidation: true,
    });
    for (let i = 0; i < this.state.arraySelector.length; i++) {
      const selectionType = this.state.arraySelector[i].selection_type;
      const shouldSetValueAsText =
        selectionType === "pick_date" ||
        selectionType === "pick_time" ||
        selectionType === "pick_time_relative" ||
        selectionType === "pick_date_and_time" ||
        selectionType === "pick_date_and_static_time" ||
        selectionType === "pick_date_spa_booker" ||
        selectionType === "pick_number" ||
        selectionType === "text_input" ||
        selectionType === "text_input_room";

      if (shouldSetValueAsText) {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: [{ value: this.state.arraySelector[i].values || "-" }],
        });
      } else if (selectionType === "pick_product_price") {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: this.state.arraySelector[i].values,
        });
      } else {
        selectionOptions.push({
          id: this.state.arraySelector[i].id,
          type: selectionType,
          index: i,
          values: filter(this.state.arraySelector[i].values, { select: true }),
        });
      }

      if (shouldSetValueAsText) {
        if (selectionType === "pick_date_and_time") {
          if (
            moment(this.state.arraySelector[i].values).valueOf() + 60000 <
            moment().valueOf()
          ) {
            hasError = true;
            this.setState({
              hasError: true,
              dateTimeErrorMessage: `${this.props.t(
                "DATE_TIME_ERROR_MESSAGE"
              )}`,
            });
            break;
          }
        }

        itemSelection +=
          this.state.arraySelector[i].title +
          ": " +
          (this.state.arraySelector[i].values || "-") +
          "\n";
        if (this.state.arraySelector[i].force_input) {
          if (!this.state.arraySelector[i].values) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (selectionType === "pick_one" || selectionType === "pick_one_price") {
        itemSelection += this.state.arraySelector[i].title + ": ";
        let pickOneValid = false;
        for (let l = 0; l < this.state.arraySelector[i].values.length; l++) {
          if (this.state.arraySelector[i].values[l].select) {
            if (selectionType === "pick_one_price") {
              itemSelection +=
                this.state.arraySelector[i].values[l].name +
                " (+" +
                this.state.arraySelector[i].values[l].price +
                ")\n";
            }

            if (selectionType === "pick_one") {
              itemSelection +=
                this.state.arraySelector[i].values[l].name + "\n";
            }
          }

          if (this.state.arraySelector[i].force_input) {
            if (this.state.arraySelector[i].values[l].select === true) {
              pickOneValid = true;
              break;
            }
          }
        }
        if (this.state.arraySelector[i].force_input && !pickOneValid) {
          validateDataInput = false;
          break;
        }
      }

      if (
        selectionType === "pick_multiple" ||
        selectionType === "pick_multiple_price"
      ) {
        itemSelection += this.state.arraySelector[i].title + ": ";
        let pickMultipleValid = false;
        for (let k = 0; k < this.state.arraySelector[i].values.length; k++) {
          if (this.state.arraySelector[i].values[k].select) {
            if (selectionType === "pick_multiple_price") {
              itemSelection +=
                this.state.arraySelector[i].values[k].name +
                " (+" +
                this.state.arraySelector[i].values[k].price +
                ")";
            }

            if (selectionType === "pick_multiple") {
              itemSelection +=
                this.state.arraySelector[i].values[k].name + ", ";
            }
          }
        }

        for (let k = 0; k < this.state.arraySelector[i].values.length; k++) {
          if (this.state.arraySelector[i].force_input) {
            if (this.state.arraySelector[i].values[k].select === true) {
              pickMultipleValid = true;
              break;
            }
          }
        }

        itemSelection += "\n";
        if (this.state.arraySelector[i].force_input && !pickMultipleValid) {
          validateDataInput = false;
          break;
        }
      }

      if (selectionType === "pick_dropdown") {
        const dataSelected = find(this.state.arraySelector[i].values, {
          select: true,
        });
        itemSelection += `${this.state.arraySelector[i].title}: ${get(
          dataSelected,
          "name",
          ""
        )}\n`;
        if (
          this.state.arraySelector[i].force_input &&
          isUndefined(dataSelected)
        ) {
          validateDataInput = false;
          break;
        }
      }
    }

    if (!validateDataInput) {
      this.setState({ requiredField: true });
    } else if (hasError) {
    } else {
      this.setState({
        showConfirmation: !this.state.showConfirmation,
        itemSelection,
        selectionOptions,
      });
      Property.setNoteItemSelection(itemSelection);
    }
  };

  showSecondModal = () => {
    this.setState({
      showConfirmation: false,
      showSecondConfirmation: !this.state.showSecondConfirmation,
    });
  };

  onChange = (key, val) => {
    this.setState({
      [key]: val,
    });
  };

  confirmationModalView = () => {
    if (!this.state.showConfirmation) {
      return;
    }

    const { lastName, roomNumber, okDisabled, showConfirmation } = this.state;
    let btnOkDisable = okDisabled;
    if ((isEmpty(lastName) || isEmpty(roomNumber)) && !okDisabled) {
      btnOkDisable = true;
    }

    return (
      <ConfirmOrderAskRoomLastNameModal
        showConfirmation={showConfirmation}
        openCloseModal={(showConfirmation) =>
          this.setState({ showConfirmation })
        }
        onConfirm={() => this.showSecondModal()}
        loading={false}
        onChange={this.onChange}
        okDisabled={btnOkDisable}
      />
    );
  };

  confirmationTwoModalView = () => {
    if (!this.state.showSecondConfirmation) {
      return;
    }
    return (
      <ConfirmationFulfillmentModal
        content={`${this.props.t("YOU_HAVE_JUST_REQUEST")} "${
          this.state.fulfillmentNode.title
        }" ${this.props.t("FOR_ROOM")} ${this.state.roomNumber}?`}
        showConfirmation={this.state.showSecondConfirmation}
        autoReplyText={this.state.auto_reply_message}
        openCloseModal={(showSecondConfirmation) =>
          this.setState({ showSecondConfirmation })
        }
        onConfirm={() => this.onConfirm()}
        loading={false}
        okDisabled={this.state.okDisabled}></ConfirmationFulfillmentModal>
    );
  };
  b64toBlob = (imageData, memeType = "image/png", name = "image.png") => {
    let blob = null;
    if (imageData) {
      var startIndex = imageData.indexOf("base64,") + 7;
      var b64 = imageData.substr(startIndex);
      let byteCharacters = window.atob(b64);
      let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);
      blob = new Blob([byteArray], {
        type: memeType,
        name: name,
      });
    }
    return blob;
  };

  onConfirm = async () => {
    const cartItem = FulfillmentNode.getCartItem();
    const deviceType = Property.getDeviceType();
    const platform = Property.getPlatform();
    const { lastName, roomNumber } = this.state;
    const {
      fulfillmentNode,
      fulfillmentNodeSchema,
      itemSelection,
      auto_reply_message,
      propertyUid,
      lobbyRowId,
      language,
    } = this.state;
    const fulfillmentTypeName = fulfillmentNodeSchema.data.fulfillment_type;
    const autoReplyMessage = auto_reply_message;
    const node = {
      id: fulfillmentNode.core_id,
      type: null,
      selection_options: cartItem.selection_options,
    };
    const requestTitle = fulfillmentNode.title;
    const autoReminder = cartItem.auto_reminder_base_time;
    this.setState({ loading: true, okDisabled: true }, async () => {
      await this.getAccessToken(this.state.propertyUid);
      FulfillmentService.postFulfillment(
        this.state.accessToken,
        fulfillmentTypeName,
        deviceType,
        itemSelection,
        autoReplyMessage,
        requestTitle,
        node,
        platform,
        lastName,
        roomNumber,
        FulfillmentNode.getToken(),
        autoReminder
      )
        .then(
          async function (result) {
            const fulfillmentId = result.data.id;
            const selectors = this.state.arraySelector;
            FulfillmentNode.clearUploadedPhotos();
            for (let i = 0; i < selectors.length; i++) {
              const selectionType = selectors[i].selection_type;
              if (
                selectionType === "signature" ||
                selectionType === "add_photo"
              ) {
                const file = selectors[i].values;
                const photo =
                  (file && this.b64toBlob(file.uri, file.type, file.name)) ||
                  "";
                await FulfillmentService.postUploadPhoto(
                  this.state.accessToken,
                  photo,
                  fulfillmentId,
                  selectors[i].title
                ).then(function (result) {
                  FulfillmentNode.addUploadedPhotos(result.data);
                });
              }
            }
            result.data.cart_item = Property.getBasketOptions();
            Property.setOrderSuccess(result);
            Property.clearCartItem();
            this.props.history.push(
              `/${propertyUid}/lobby/${lobbyRowId}/fulfillments/${fulfillmentNode.core_id}/success?language=${language}`
            );
          }.bind(this)
        )
        .catch((res) => {
          this.setState({
            showConfirmation: false,
            showSecondConfirmation: false,
            hasError: true,
            errorMessage:
              get(res, "response.data.error") || this.props.t("RETRY"),
            loading: false,
            lastName: "",
            roomNumber: "",
            okDisabled: false,
          });
        });
    });
  };

  modalErrorStatus() {
    this.setState({
      showConfirmation: false,
      showSecondConfirmation: false,
      hasError: false,
      errorMessage: "",
      loading: false,
      lastName: "",
      roomNumber: "",
      okDisabled: false,
    });
  }

  render() {
    const {
      propertyUid,
      language,
      lobbyRowId,
      presets,
      error,
      loading,
      arraySelector,
      lobbyRow,
      fulfillmentNode,
      fulfillmentNodeSchema,
    } = this.state;
    let windowWidth = window.innerWidth;
    let windowHeight = (window.innerHeight * 0.4).toFixed(0);
    if (windowWidth > 1280) {
      windowWidth = 1280;
    }
    windowHeight = 400;

    return (
      <>
        {loading && !error && (
          <div
            style={{
              display: "flex",
              height: "100vh",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <LoadingIcon loadingState={true} />
          </div>
        )}
        {!loading && !error && (
          <div className="flex flex-col w-full">
            <BrandStyleSheet brandStyleSheet={presets.app_brand_stylesheet} />
            <div className="flex flex-col mb-20 h-full">
              <TopBar
                previousUrl={`/${propertyUid}/lobby/${lobbyRowId}?token=${FulfillmentNode.getToken()}&language=${language}`}
                previousTitle={
                  lobbyRow && lobbyRow.title ? lobbyRow.title : undefined
                }
                currentPage={"productDetail"}
              />
              {this.confirmationModalView()}
              {this.confirmationTwoModalView()}
              {this.state.hasError && (
                <ErrorModal
                  stateModal={this.state.hasError}
                  openCloseModal={() => this.modalErrorStatus()}
                  textTitle={this.props.t("ERROR")}
                  btnErrorText={this.props.t("OK")}
                  childText={
                    this.state.errorMessage || this.state.dateTimeErrorMessage
                  }
                />
              )}
              <section
                id="content"
                className="sectionContent w-full h-full">
                {fulfillmentNode && (
                  <div className="w-full flex flex-col">
                    {fulfillmentNode.picture && (
                      <LazyLoadImage
                        placeholderSrc={placeholderSquare}
                        alt={fulfillmentNode.title}
                        src={storeFunction.resizeImage(
                          fulfillmentNode.picture,
                          600,
                          600
                        )}
                        wrapperClassName="w-full"
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "60%",
                          maxHeight: `${windowHeight}px`,
                          display: "absolute",
                        }}
                      />
                    )}
                    <div className="w-full flex flex-col flex-1">
                      <div className="flex-1 w-full flex flex-col">
                        <ProductPanel className="pt-6">
                          {fulfillmentNode.title && (
                            <ListHeaderTitle
                              app_home_list_item_title_color={
                                presets.app_home_list_item_title_color
                              }
                              className={"itemListTextStoreTitle"}>
                              {fulfillmentNode.title}
                            </ListHeaderTitle>
                          )}
                          {fulfillmentNode.subtitle && (
                            <ListSubTitle
                              app_home_list_item_subtitle_color={
                                presets.app_home_list_item_subtitle_color
                              }
                              className={"itemListTextStoreTitle"}>
                              {fulfillmentNode.subtitle}
                            </ListSubTitle>
                          )}
                        </ProductPanel>
                        {arraySelector &&
                          arraySelector.map((item, index) => {
                            return (
                              <Flex
                                container
                                flex={1}
                                margin={"16px 0"}
                                key={index}>
                                <Selector
                                  selectionType={item.selection_type}
                                  item={item}
                                  index={index}
                                  onChange={(event) => {
                                    arraySelector[index].values =
                                      event.target.value;
                                    this.setState({ arraySelector });
                                  }}
                                  refreshData={(data, id) =>
                                    this.refreshArraySelector(data, id)
                                  }
                                  checkValidation={this.state.checkValidation}
                                />
                              </Flex>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                )}
                {fulfillmentNodeSchema &&
                  this.bottomBar(
                    presets,
                    "/",
                    fulfillmentNodeSchema.data.button_text ||
                      this.props.t("REQUEST")
                  )}
              </section>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(FulfillmentDetail);
